export default __webpack_public_path__ + "static/media/menuAbrir.0bc96c1e.svg";